"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabbedSwitchNavigation = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importDefault(require("styled-components"));
var global_1 = require("../Global/global");
var TabNavWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  overflow: auto;\n"], ["\n  height: 100%;\n  overflow: auto;\n"])));
var TabbedNavigationWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  position: relative;\n  z-index: ", ";\n  padding: ", ";\n  padding-bottom: 0;\n  box-shadow: ", ";\n  box-sizing: border-box;\n  font-size: 14px !important;\n"], ["\n  background-color: ", ";\n  position: relative;\n  z-index: ", ";\n  padding: ", ";\n  padding-bottom: 0;\n  box-shadow: ", ";\n  box-sizing: border-box;\n  font-size: 14px !important;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.gray[10];
}, global_1.Z_INDEX.SUB_HEADER, function (_a) {
    var theme = _a.theme;
    return theme.spacing.medium;
}, global_1.BOX_SHADOW_COMPONENT);
var TabbedSwitchNavigation = function (props) {
    var history = (0, react_router_dom_1.useHistory)();
    var location = history.location;
    var handleChange = function (key) {
        history.push('/' + props.root + '/' + key + history.location.search);
    };
    return (react_1.default.createElement(TabNavWrapper, null,
        react_1.default.createElement(TabbedNavigationWrapper, null,
            react_1.default.createElement(storm_ui_1.TabbedNavigation, null, props.cases.map(function (_a) {
                var key = _a.key, label = _a.label;
                return (react_1.default.createElement(storm_ui_1.TabbedNavigationItem, { key: key, active: location.pathname.startsWith('/' + props.root + '/' + key), "aria-selected": location.pathname.startsWith('/' + props.root + '/' + key), label: label, onClick: function () { return handleChange(key); } }));
            }))),
        props.cases.map(function (_a) {
            var key = _a.key, children = _a.children;
            return (react_1.default.createElement(react_router_dom_1.Switch, { key: key },
                react_1.default.createElement(react_router_dom_1.Route, { path: '/' + props.root + '/' + key }, children)));
        })));
};
exports.TabbedSwitchNavigation = TabbedSwitchNavigation;
var templateObject_1, templateObject_2;
